import React from 'react';
import { createAuction } from '../../../../../../models/auctions';
import { getAllMasks } from '../../../../../../models/masks';
import swal from 'sweetalert';

import { Map } from '../../../../../helpers/map';
import i18n from '../../../../../../i18n';
import { getGroupsList , getGroup} from '../../../../../../models/groups';

export class CreateAuctionGeneral extends React.Component {
  constructor() {
    super();
    this.state = {
      lat: 23.588,
      lng: 58.3829,
      input: {
        is_extra_time: false,
        is_featured: true,
        is_zakath: false,
        auto_approval: true,
        is_vat_included: false,
        is_service_charge_included: false,
        is_service_charge_vat_included: false,
      },
      tempArray: {},
      errors: {},
      masks: {},
      groups: {},
      categories: {},
      organizations: {},
      enquiries: [{ label: '', value: '' }],
      jsonLabel: '',
      jsonValue: '',
      categoryList: '',
      places: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getLocation = this.getLocation.bind(this);
    this.toggleChange = this.toggleChange.bind(this);
    this.toggleZakath = this.toggleZakath.bind(this);
    this.toggleFeatured = this.toggleFeatured.bind(this);
    this.toggleAutoApproval = this.toggleAutoApproval.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let input = this.state.input;
    input.category = this.props.category;
    input.organization = this.props.organization;
    this.loadAllMasks();
    this.loadAllGroups();
  }

  async loadAllMasks() {
    const response = await getAllMasks();
    let masks = response.data;
    this.setState({ masks });
  }

  async loadAllGroups() {
    const response = await getGroupsList();
    let groups = response.data;
    this.setState({ groups });
  }

  async getGroup(id) {
    const response = await getGroup(id);
    let group = response.data;
    let input = this.state.input;
    input.start_date = group.start_date;
    input.end_date = group.end_date;
    input.reg_start_date = group.reg_start_date;
    input.reg_end_date = group.reg_end_date;
    input.description = group.description;
    input.description_ar = group.description_ar;
    input.terms = group.terms;
    input.terms_arabic = group.terms_arabic;
    input.payment_type = group.payment_type;
    input.payment_amount = group.amount;
    input.is_extra_time = group.is_extra_time;
    input.extra_time = group.extra_time;
    input.has_auto_bidding = group.has_auto_bidding;
    input.is_vat_included = group.is_vat_included;
    input.is_service_charge_included = group.is_service_charge_included;
    input.is_service_charge_vat_included = group.is_service_charge_vat_included;
    this.setState({ input });
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
    if (event.target.name === 'group') {
      this.getGroup(event.target.value);
    }
  }

  createDate(dt) {
    return dt ? new Date(dt.replace(/-/g, '/')) : null;
  }

  toggleChange = () => {
    let input = this.state.input;
    input.is_extra_time = !this.state.input.is_extra_time;
    this.setState({ input });
  };

  toggleZakath = () => {
    let input = this.state.input;
    input.is_zakath = !this.state.input.is_zakath;
    this.setState({ input });
  };

  toggleFeatured = () => {
    let input = this.state.input;
    input.is_featured = !this.state.input.is_featured;
    this.setState({ input });
  };

  toggleAutoApproval = () => {
    let input = this.state.input;
    input.auto_approval = !this.state.input.auto_approval;
    this.setState({ input });
  };

  handleSelect = (selectedOption) => {
    let updateExtraTime = '';
    const checkCategory = (obj) => obj.label === 'phoneNumber';
    if (!selectedOption.some(checkCategory)) {
      updateExtraTime = true;
    }
    const categoryArr = selectedOption.map((opt) => opt.value);
    let input = this.state.input;
    input.is_extra_time = updateExtraTime;
    this.setState({ categoryList: categoryArr, input });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    try {
      let payload = this.state.input;
      payload.enquiries = this.state.enquiries;
      payload.categories = this.state.categoryList;
      payload.category = this.props.category;
      payload.organization = this.props.organization;
      payload.latitude = this.state.lat;
      payload.longitude = this.state.lng;
      const response = await createAuction(payload);
      if (response && response.data && response.success) {
        swal(i18n.t('success'), response.message, 'success');
        setTimeout(() => {
          window.location.href = '/edit_auction/' + response.data.id + '?tab=images';
        }, 3000);
      } else {
        let error_message = response.message;
        let resObject = response.data;
        for (const key in resObject) {
          if (Object.hasOwnProperty.call(resObject, key)) {
            let element = resObject[key];
            error_message += '\n' + element;
          }
        }
        swal('Failed', error_message, 'error');
      }
    } catch (err) {
      console.log(err);
    }
  };

  getLocation(lat, lng) {
    this.setState({ lat: lat, lng: lng });
  }

  render() {
    let groups = this.state.groups;
    return (
      <form id="UpdateProfile" autoComplete="off" onSubmit={this.handleSubmit}>
        {/* Two-column grid layout */}
        <div className="form-content">
          {/* ========== LEFT COLUMN ========== */}
          <div className="left-column">

            {/* Group & Config */}
            <div className="form-section">
              <h2>{i18n.t('auction_group')} & Configuration</h2>
              <div className="form-field form-field-margin-bottom">
                <label>{i18n.t('auction_group')}</label>
                <select
                  name="group"
                  value={this.state.input.group}
                  onChange={this.handleChange}
                >
                  <option value="">--{i18n.t('group')}--</option>
                  {groups.length > 0 &&
                    groups.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.group_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t('contract_number')}</label>
                  <input
                    type="text"
                    name="contract_number"
                    placeholder={i18n.t('contract_number')}
                    value={this.state.input.contract_number}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>{i18n.t('payment_type')}</label>
                  <select
                    name="payment_type"
                    value={this.state.input.payment_type}
                    onChange={this.handleChange}
                  >
                    <option value="">--Select--</option>
                    <option value="Online">{i18n.t('online')}</option>
                    <option value="Offline">{i18n.t('offline')}</option>
                    <option value="Both">Supports both Online & Offline</option>
                  </select>
                </div>
              </div>
              <div className="form-field form-field-margin-bottom">
                <label>{i18n.t('Enrollment amount')}</label>
                <input
                  type="text"
                  name="payment_amount"
                  placeholder={i18n.t('Enrollment amount')}
                  value={this.state.input.payment_amount}
                  onChange={this.handleChange}
                />
              </div>
            </div>

            {/* Title & Description */}
            <div className="form-section">
              <h2>{i18n.t('title')} & {i18n.t('description')}</h2>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t('title')} *</label>
                  <input
                    type="text"
                    required={true}
                    name="title"
                    placeholder={i18n.t('title')}
                    value={this.state.input.title}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>{i18n.t('title_ar')} *</label>
                  <input
                    type="text"
                    required={true}
                    name="title_ar"
                    placeholder={i18n.t('title_ar')}
                    value={this.state.input.title_ar}
                    onChange={this.handleChange}
                    dir="rtl"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t('description')} *</label>
                  <textarea
                    required={true}
                    name="description"
                    placeholder={i18n.t('description')}
                    value={this.state.input.description}
                    onChange={this.handleChange}
                    rows={6}
                  ></textarea>
                </div>
                <div className="form-field">
                  <label>{i18n.t('description')} ({i18n.t('arabic')}) *</label>
                  <textarea
                    required={true}
                    name="description_ar"
                    placeholder={i18n.t('description')}
                    value={this.state.input.description_ar}
                    onChange={this.handleChange}
                    dir="rtl"
                    rows={6}
                  ></textarea>
                </div>
              </div>
            </div>

            {/* Pricing */}
            

            {/* Dates */}
            <div className="form-section">
              <h2>{i18n.t('auction_details')}</h2>
              <div className="form-row">
                <div className="form-field">
                  <label>
                    {i18n.t('start_date')}{' '}
                    {this.state.input.start_date ? '(' + this.state.input.start_date + ')' : ''}
                  </label>
                  <input
                    type="datetime-local"
                    name="start_date"
                    value={this.state.input.start_date}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>
                    {i18n.t('end_date')}{' '}
                    {this.state.input.end_date ? '(' + this.state.input.end_date + ')' : ''}
                  </label>
                  <input
                    type="datetime-local"
                    name="end_date"
                    value={this.state.input.end_date}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>
                    {i18n.t('reg_start_date')}{' '}
                    {this.state.input.reg_start_date ? '(' + this.state.input.reg_start_date + ')' : ''}
                  </label>
                  <input
                    type="datetime-local"
                    name="reg_start_date"
                    value={this.state.input.reg_start_date}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>
                    {i18n.t('reg_end_date')}{' '}
                    {this.state.input.reg_end_date ? '(' + this.state.input.reg_end_date + ')' : ''}
                  </label>
                  <input
                    type="datetime-local"
                    name="reg_end_date"
                    value={this.state.input.reg_end_date}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Terms */}
            <div className="form-section">
              <h2>{i18n.t('terms_conditions')}</h2>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t('terms_conditions')} *</label>
                  <textarea
                    required={true}
                    name="terms"
                    placeholder={i18n.t('terms_conditions')}
                    value={this.state.input.terms}
                    onChange={this.handleChange}
                    rows={6}
                  ></textarea>
                </div>
                <div className="form-field">
                  <label>{i18n.t('terms_conditions')} ({i18n.t('arabic')}) *</label>
                  <textarea
                    required={true}
                    name="terms_arabic"
                    placeholder={i18n.t('terms_conditions')}
                    value={this.state.input.terms_arabic}
                    onChange={this.handleChange}
                    dir="rtl"
                    rows={6}
                  ></textarea>
                </div>
              </div>
            </div>

            
          </div>

          {/* ========== RIGHT COLUMN ========== */}
          <div className="right-column">

            <div className="form-section">
              <h2>{i18n.t('financial_details')}</h2>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t('price')}</label>
                  <input
                    type="text"
                    name="start_amount"
                    placeholder="Price"
                    value={this.state.input.start_amount}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>{i18n.t('gurantee_amount')}</label>
                  <input
                    type="text"
                    name="guarantee_amount"
                    placeholder={i18n.t('gurantee_amount')}
                    value={this.state.input.guarantee_amount}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="form-field form-field-margin-bottom">
                <label>{i18n.t('visit_amount')}</label>
                <input
                  type="text"
                  name="visit_amount"
                  placeholder={i18n.t('visit_amount')}
                  value={this.state.input.visit_amount}
                  onChange={this.handleChange}
                />
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t('incr_amount')}</label>
                  <input
                    type="text"
                    name="bid_increment"
                    placeholder="Increment Amount"
                    value={this.state.input.bid_increment}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>{i18n.t('incr_amount')} (comma separated)</label>
                  <input
                    type="text"
                    name="increment_numbers"
                    placeholder="eg: 100,200,300..."
                    value={this.state.input.increment_numbers}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Config & Toggles */}
            <div className="form-section">
              <h2>{i18n.t('config_and_uploads')}</h2>

              <div className="toggle-field">
                <label>Is Featured</label>
                <div
                  className={`toggle ${this.state.input.is_featured ? 'active' : ''}`}
                  onClick={this.toggleFeatured}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>Is Zakath</label>
                <div
                  className={`toggle ${this.state.input.is_zakath ? 'active' : ''}`}
                  onClick={this.toggleZakath}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>Auto Approval</label>
                <div
                  className={`toggle ${this.state.input.auto_approval ? 'active' : ''}`}
                  onClick={this.toggleAutoApproval}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>Auto Bidding</label>
                <div
                  className={`toggle ${this.state.input.has_auto_bidding ? 'active' : ''}`}
                  onClick={() => {
                    let { input } = this.state;
                    input.has_auto_bidding = !input.has_auto_bidding;
                    this.setState({ input });
                  }}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>{i18n.t('extra_time')}</label>
                <div
                  className={`toggle ${this.state.input.is_extra_time ? 'active' : ''}`}
                  onClick={this.toggleChange}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>
              {this.state.input.is_extra_time && (
                <div className="form-field" style={{ marginTop: '12px' }}>
                  <label>{i18n.t('extra_time')} ({i18n.t('in_minutes')})</label>
                  <input
                    name="extra_time"
                    type="number"
                    value={this.state.input.extra_time}
                    onChange={this.handleChange}
                    placeholder={i18n.t('in_minutes')}
                  />
                </div>
              )}

              <div className="toggle-field">
                <label>{i18n.t('is_vat_included')}</label>
                <div
                  className={`toggle ${this.state.input.is_vat_included ? 'active' : ''}`}
                  onClick={() => {
                    let { input } = this.state;
                    input.is_vat_included = !input.is_vat_included;
                    this.setState({ input });
                  }}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>{i18n.t('is_service_charge_included')}</label>
                <div
                  className={`toggle ${this.state.input.is_service_charge_included ? 'active' : ''}`}
                  onClick={() => {
                    let { input } = this.state;
                    input.is_service_charge_included = !input.is_service_charge_included;
                    this.setState({ input });
                  }}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>{i18n.t('is_service_charge_vat_included')}</label>
                <div
                  className={`toggle ${this.state.input.is_service_charge_vat_included ? 'active' : ''}`}
                  onClick={() => {
                    let { input } = this.state;
                    input.is_service_charge_vat_included = !input.is_service_charge_vat_included;
                    this.setState({ input });
                  }}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>
            </div>

            {/* Location */}
            <div className="form-section">
              <h2>{i18n.t('location')}</h2>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t('location')}</label>
                  <input
                    type="text"
                    name="location"
                    placeholder={i18n.t('location')}
                    value={this.state.input.location}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>{i18n.t('location')} ({i18n.t('arabic')})</label>
                  <input
                    type="text"
                    name="location_ar"
                    placeholder={i18n.t('location') + ' (' + i18n.t('arabic') + ')'}
                    value={this.state.input.location_ar}
                    onChange={this.handleChange}
                    dir="rtl"
                  />
                </div>
              </div>
              <div className="form-field form-field-margin-bottom">
                <Map
                  getLocation={this.getLocation}
                  defaultLocation={{ lat: this.state.lat, lng: this.state.lng }}
                />
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Latitude</label>
                  <input
                    type="text"
                    name="latitude"
                    value={this.state.lat}
                    onChange={(event) => this.setState({ lat: event.target.value })}
                  />
                </div>
                <div className="form-field">
                  <label>Longitude</label>
                  <input
                    type="text"
                    name="longitude"
                    value={this.state.lng}
                    onChange={(event) => this.setState({ lng: event.target.value })}
                  />
                </div>
              </div>
            </div>

            

          </div>
        </div>

        {/* Submit Footer */}
        <div className="action-buttons-l2 border-top-light">
          <button
            type="button"
            className="button1 button1-gray"
            onClick={() => window.history.back()}
          >
            {i18n.t('cancel')}
          </button>
          <button type="submit" className="button1 button1-primary">
            Save & Continue
          </button>
        </div>
      </form>
    );
  }
}